var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.063 4.501c.42 0 .761-.336.761-.75a.756.756 0 00-.761-.75.756.756 0 00-.762.75c0 .414.34.75.761.75z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.063 0c-1.07 0-2.098.416-2.859 1.157A3.97 3.97 0 000 3.96C0 6.7 3.58 9.75 3.732 9.88a.513.513 0 00.66 0c.178-.13 3.733-3.18 3.733-5.92a3.97 3.97 0 00-1.204-2.803A4.095 4.095 0 004.062 0zm0 5.5c-.352 0-.696-.103-.988-.295a1.756 1.756 0 01-.655-.785 1.725 1.725 0 01.386-1.907c.248-.245.565-.412.91-.48a1.803 1.803 0 011.027.1c.324.133.602.357.797.645a1.731 1.731 0 01-.22 2.21 1.792 1.792 0 01-1.258.512z",
    fill: "#343434"
  })));
}
export default SvgLocation;